export const environment = {
    production: false,
    envName: 'dev',
    bypassAuth: false,
    apiUrl: 'https://devservices.trane.com',
    erpApiKey: '82a10ba2-6ed9-4ad7-9f4b-4682d4ad303a',
    orderNApiKey: '019c0b7a-1948-75be-bc18-dc42e77b279c',
    wennsoftApiKey: '01964921-7c08-7927-ab89-24d5b36020b1',
    erpODataUrl: `https://development.api.chvac.trane.com/erp`,
    wennsoftODataUrl: 'https://development.api.chvac.trane.com/wennsoft',
    commissionApiKey: '153015a3-1261-4033-91b2-f9ecc116f773',
    dmcApplicationUrl: 'https://devdmc.trane.com',
    serviceUrl: 'https://development.api.chvac.trane.com',
    mTopssUrl: 'http://dev.webtopss.com',
    prodUrl: 'https://salestools.trane.com',
    deployedEnv: 'Development',
    crmCompanyUrl: 'http://tranecrmtest/psp/crmtest/EMPLOYEE/CRM/c/RB_MANAGE_CUSTOMER_INFORMATION.RD_COMPANY_2.GBL',
    crmOppyUrl: 'http://tranecrmtest/psp/crmtest/EMPLOYEE/CRM/c/RSF_OPPORTUNITY.RSF_OPPORTUNITY.GBL',
    erpCreatePencilDocumentKey: 'b21c0d0b-c935-46f5-938a-a010df3c173d',
    enableAp3WayMatchTile: true,
    enableRebalancing: true,
    enableCreditApprovals: true,
    enableCreditApprovalGuidedQuestions: true,
    enableCopyDown: true,
    enableBilling: true,
    mendixMarginPricingToolUrl: 'https://marginspricing-accp.mendixcloud.com',
    enablePrevalidation: true,
    enableMirrorSalesOrder: true,
    enablePricingValidation: true,
    enableLockStatus: true,
    enableReadOnlyLockStatus: true,
    enableSalesOrderDetailsEdit: true,
    enableSalesOrderDetailsReport: true,
    enableTableau: true,
    enableAssignSalesOrders: true,
    enableOrderSummary: true,
    enableOnePricingPolicy: true,
    enableProjectListFilterAndSort: true,
    enableProductReturns: true,
    enableLeadershipSpa: true,
    enableLeadershipSraFamilyView: true,
    enableDynamicPoackStamping: true,
    enableMaterialsRequisition: true,
    enablePeoplesoftPricingPolicy: true,
    enableMultipleshipmentDeliverywindowUpdate: true,
    enableR12PricingPolicy: true,
    hideBidsDropdownInPriceSummary: true,
    sfOppyUrl: 'https://tranetechnologies--dchvacint.sandbox.my.salesforce.com',
    enableCustomReport: true,
    enableBondCoopPercentage: true,
    enableBondCoopLumpSum: true,
    enableServiceAgreementTemplate: true,
    enablePoAddendumForWorkPackages: true,
    enablePlaceholderServiceActivityEnhancement: true,
    enableRemoveSuppliedMaterial: false,
    enableRegionalOfficeItems: true,
    enableCopyToOfficeItems: true,
    enableOfficeItemsForWorkPackages: true,
    enableOfficeItemsForServiceWorkPackages: true,
    enableNewProductApiIntegration: true,
    enableMarginPricingTool: false,
    enableForecastOnlyEnhancement: true,
    enableFieldTrackingAndIOS: true,
    enableReturnsInPriceSummary: true,
    enableManualProductEntry: true,
    enableTipPackages: true,
    enableIntegratedTransmit: true,
    enableIOSNotification: true,
    enableCanadaFeature: true,
    enableBuySellStrategicFeature: true,
    enableNonTraneForCanada: true,
    enableUserEnteredFcstperiod: true,
    consolidatedBillingReturnsEnabled: true,
    enableRelease268Stabilization: true,
    enableCreditSupplementSection: true,
    enableBackgroundTransmit: false,
    enableReturnsSerialNumber: true,
    enableCxiSurvey: true,
    identificationType: 'Azure',
    azureClientId: '6690bab6-91d3-4c37-a3ca-2e3bf148124e',
    azureAuthority: 'https://corpextdev.b2clogin.com/corpextdev.onmicrosoft.com/B2C_1A_OIDC_WORKSIGHT',
    azureApiScopes: ['https://corpextdev.onmicrosoft.com/7c2ab0cb-4387-46f8-ae4c-efa11670e2fa/Read',
        'https://corpextdev.onmicrosoft.com/7c2ab0cb-4387-46f8-ae4c-efa11670e2fa/AutoScope',
        'https://corpextdev.onmicrosoft.com/7c2ab0cb-4387-46f8-ae4c-efa11670e2fa/Employees.Read.All'],
    azureAuthorityDomain: 'corpextdev.onmicrosoft.com',
    applicationDefaultPath: '',
    enableDOE: true,
    enableErp: true,
    enableConsolidatedBilling: true,
    enableTransmitValidation: true,
    enableCustomerRequests: true,
    enableGrabCreditJobLock: true,
    enableCaseResolutionCustomReport: true,
    erpADGroup: 'TT-CHVAC-WORKSIGHT-ERP-PILOT',
    enableLOA: true,
    enableOrderLineEdit: true,
    iProcurementLink: 'http://ebsdevas.ad.corp.global/OA_HTML/OA.jsp?page=/oracle/apps/icx/por/rcv/webui/IcxPorRcvHomePG',
    enableSovCategories: true,
    enableTraneProduct: true,
    enableTaxDeterminationRecentUpdates: true,
    enablePartialCostAdjustment: true,
    enableRefreshSPA: true,
    enableProjectCancellationWithCreditHold: true,
    enablePercentageFieldValidation: true,
    worksightWebSocketUrl: 'wss://development.ws.chvac.trane.com/worksight',
    enableWorksightWebSocket: true,
    isExperimentalModeToggleEnabled: true,
    bidApi: 'https://development.api.chvac.trane.com/bid/api',
    billingBusinessApi: 'https://development.api.chvac.trane.com/bill-business/api',
    businessDataApi: 'https://development.api.chvac.trane.com/business-data/api',
    businessRulesEngineApi: 'https://development.api.chvac.trane.com/business-rule/api',
    camGatewayApi: 'https://development.api.chvac.trane.com/cam/api',
    changeControlApi: 'https://development.api.chvac.trane.com/change-control/api',
    costForecastApi: 'https://development.api.chvac.trane.com/costforecast/api',
    costForecastBusinessApi: 'https://development.api.chvac.trane.com/forecast-cost-business/api',
    creditJobLookUpApi: 'https://development.api.chvac.trane.com/job-credit-lookup/api',
    crmApi: 'https://development.api.chvac.trane.com/crm/api',
    designAuthApi: 'https://development.api.chvac.trane.com/design-auth/api',
    documentApi: 'https://ptpmbx9y6t.us-east-1.awsapprunner.com/api',
    documentMigrationApi: 'https://development.api.chvac.trane.com/document-migration/api',
    documentPackageApi: 'https://development.api.chvac.trane.com/document-package/api',
    erpApi: 'https://development.api.chvac.trane.com/erp/api',
    equipmentInventoryApi: 'https://development.api.chvac.trane.com/equipment-inventory/api',
    financialApi: 'https://development.api.chvac.trane.com/financial/api',
    forecastWorkerApi: 'https://development.api.chvac.trane.com/forecast/api',
    fulfillmentApi: 'https://development.api.chvac.trane.com/fulfillment/api',
    fulfillmentWorkerApi: 'https://development.api.chvac.trane.com/fulfillment-worker/api',
    interventionApi: 'https://development.api.chvac.trane.com/intervention/api',
    jobApi: 'https://development.api.chvac.trane.com/job/api',
    jobDirectApi: 'https://cqpqcneyej.us-east-1.awsapprunner.com/api',
    jobScoringApi: 'https://development.api.chvac.trane.com/job-score/api',
    jobSelectionApi: 'https://development.api.chvac.trane.com/job-selection/api',
    lcuLookupApi: 'https://development.api.chvac.trane.com/lcu-lookup/api',
    lynxJobApi: 'https://development.api.chvac.trane.com/job-lynx/api',
    manualPaymentRequestApi: 'https://development.api.chvac.trane.com/manual-payment-request/api',
    manualPymtReqGatewayApi: 'https://development.api.chvac.trane.com/manual-payment/api',
    manufacturingDataMaintenanceApi: 'https://development.api.chvac.trane.com/manufacture-data-maint/api',
    manufacturingOrderGatewayApi: 'https://development.api.chvac.trane.com/manufacture-order/api',
    manufacturingOrderMaintenanceApi: 'https://development.api.chvac.trane.com/manufacture-order-maint/api',
    manufacturingOrderProcessingApi: 'https://development.api.chvac.trane.com/manufacture-order-proc/api',
    messengerApi: 'https://development.api.chvac.trane.com/messenger/api',
    orderApi: 'https://development.api.chvac.trane.com/order/api',
    orderGatewayApi: 'https://development.api.chvac.trane.com/order-access/api',
    orderHistoryApi: 'https://development.api.chvac.trane.com/order-history/api',
    orderPollerApi: 'https://development.api.chvac.trane.com/order-worker/api',
    orderedCommissionApi: 'https://development.api.chvac.trane.com/commission-ordered/api',
    orderingApi: 'https://development.api.chvac.trane.com/ordering/api',
    orderingCommissionApi: 'https://development.api.chvac.trane.com/commission-order/api',
    orderNApi: 'https://development.api.chvac.trane.com/order-n/api',
    poAckApi: 'https://8gj7xgvj3r.us-east-1.awsapprunner.com/api',
    partnerIntegrationApi: 'https://development.api.chvac.trane.com/partner-integration/api',
    priceCalculatorApi: 'https://development.api.chvac.trane.com/price-calculator/api',
    priceRollupApi: 'https://development.api.chvac.trane.com/price-rollup/api',
    pricingApi: 'https://development.api.chvac.trane.com/price/api',
    pricingAuthOfficeManagementApi: 'https://development.api.chvac.trane.com/price-management/api',
    pricingJobApi: 'https://development.api.chvac.trane.com/job-price/api',
    pricingWebGatewayApi: 'https://development.api.chvac.trane.com/price-web/api',
    productApi: 'https://development.api.chvac.trane.com/product/api',
    productMaintenanceApi: 'https://development.api.chvac.trane.com/product-maintenance/api',
    rebalancingApi: 'https://development.api.chvac.trane.com/rebalance/api',
    rebalancingPollerApi: 'https://development.api.chvac.trane.com/rebalnce-worker/api',
    revenueBusinessApi: 'https://development.api.chvac.trane.com/business-revenue/api',
    salesRollupApi: 'https://development.api.chvac.trane.com/sales-rollup/api',
    salesWebGatewayApi: 'https://phevf8tnes.us-east-1.awsapprunner.com/api',
    spectrumGatewayApi: 'https://development.api.chvac.trane.com/spectrum/api',
    splitSystemsApi: 'https://development.api.chvac.trane.com/split-system/api',
    supportApi: 'https://development.api.chvac.trane.com/support/api',
    trackerApi: 'https://development.api.chvac.trane.com/tracker/api',
    unitCosterApi: 'https://development.api.chvac.trane.com/unit-cost/api',
    userApi: 'https://development.api.chvac.trane.com/user/api',
    workPackageApi: 'https://development.api.chvac.trane.com/work-package/api',
    workPackageGatewayApi: 'https://development.api.chvac.trane.com/work-package-access/api',
    workPackageWorkerApi: 'https://development.api.chvac.trane.com/work-package-worker/api',
    enableCachedDb: true,
    enable290ReleaseFeatures: true,
    enableTaxExemptionValidation: true,
    enableOrderLineQuantitySplit: true,
    enableSalesOrderShipToAddress: true,
    enableSalesOrderSelectionSummary: true,
    enableSelectionDeScope: true,
    enableMultipleOrderLineUpdate: true,
    enableMultiOffice: true,
    enableSovButtonEnhancement: true,
    enableSovValidation: true,
    enablePreliminaryDetailedV3: true,
    enableSovShipToAddressValidation: true,
    enableProjectTaskCloseout: true,
    enableSovShipToDropdown: true,
    enableSpaSalesIssued: true,
    enableRejectStatusInReworkCase: true,
    enableNonTraneShipmentTracking: true,
    enableForecastingV4: true,
    enablePartialCreditForContracting: true,
    enableTipImportInProjectCreation: true,
    enableProductReturnsForContracting: true,
    enableHomepageTile: true,
    enableIndependentOfficeFeature: true,
    enableNoCharge: true,
    enableChangeOrderEndUserFeedback: true,
    enableNewFieldChangeReport: true,
    enableEquipmentProgressiveBilling: true,
    enableTaxAddressValidation: true,
    enableZeroDollarChangeOrder: true,
    enableServiceAgreement: true,
    enableRiskFlagForEquipmentProject: true,
    enableEndUserFeedback: true,
    enableVirtualReturns: true,
    enableSpecialTaxCleanup: true,
    salesIssuedSpaOfficeList: '10,30',
    enableSeperateBillingRequest: true,
    enableTaxExemption296Feature: true,
    enableChangeOrdersInSupplied: true,
    enableArchivedOracleProject: true,
    enableArchivedCaseView: true,
    enableCorrectionButtonHide: true,
    enableAddressIdDisplay: true,
    enableReplicateSchedule: true,
    enableInvoiceShipToAddressValidation: true,
    enableSuppliedScopeTaxIdentifiers: true,
    enableExportListReport: true,
    enableTaxDetChangeOrderInSrvAgreement: true,
    enableContinuousExemption: true,
    enableUSADateValidation: true,
    enableCanadaEquipmentCertificate: true,
    enableCanadaServiceCertificates: true,
    enableSameSuppliedProductCodeWithDifferentPONumber: true,
    enableOnlyServiceAndEquipmentBusinessOfferings: true,
    enableOnsiteOffsiteAddress: true,
    enableNewUSEquipmentCertificates: true,
    enableEquipmentDateValidation: true,
    enableCanadaServiceCountryLevelExemptionReport: true,
    enableCanadaEquipmentCountryLevelExemptionReport: true,
    enableCanadaServiceDateValidation: true,
    enableCanadaEquipmentDateValidation: true,
    enableEotJobManagementInWorksight: true,
    worksightEotJobEnabledOffices: '170,235,240',
    enableSovAddressIdInfoNote: true,
    enableCanadaContractingCertificates: true,
    enableUsaContractingCertificates: true,
    enableCanadaContractingDateValidation: true,
    enableUSAContractingDateValidation: true,
    enableCanadaContractingTaxExemptionJurisdictionId: true,
    enableUSAContractingTaxExemptionJurisdictionId: true,
    enableProductCodeExemptionNewLayout: true,
    enableUSAContractingSuppliedScopeConfiguration: true,
    enableUSAContractingInstalledScopeConfiguration: true,
    enableCanadaProvincialLevelExemptionReport: true,
    enableUSAStateLevelExemptionReport: true,
    enableSelfDeterminationForContractingProjects: true,
    enableJobSiteAddressChange: true,
    enableTaxDeterminationPath: true,
    enableCreditRequestInvoiceMethod: true,
    enableAdditionalTaxDeterminationExemptions: true,
    enableInvoiceValidationUpdates: true,
    enableLocationPopulationFromJurisdictionsForContracting: true,
    enableTaxDeterminationAddressChangeNotification: true,
    enableValidateServiceAgreementChangeOrder: true,
    enableWorkPackageWildcardSearch: true,
    enableRevenuePolicyV2: true,
    enableCanadaServiceExemptionUseTax: true,
    enableDefaultTaxPathAndTreatment: true,
    enableOptionalExtendedWarranty: true,
    enableBuySell: true,
    enableServiceActivitiesForWorkPackages: true,
    enableForceRebalance: true,
    enableInternalSourcing: true,
    enableRevenueRecognizedWarning: true,
    enableIndependents: true,
    enableEndUserFeedbackRelease301: true,
    enableEndUserFeedbackRelease302: true,
    enableEndUserFeedbackRelease303: true,
    enableEndUserFeedbackRelease305: true,
    enableEndUserFeedbackRelease306: true,
    enableDeploymentFieldCouncilFeedback301: true,
    enableDeploymentFieldCouncilFeedback303: true,
    enableTaxExemptionCoverageDateValidation: true,
    enableContinuousTaxExemption: true,
    enableTaxDeterminationAdditionSuppliedProductCode: true,
    enablePendingCancellation: true,
    enableTaxRate: true,
    enableNewForecastingTool: true,
    enableServiceWorkPackageValidation: true,
    enablePurchaseOrders: true,
    enableForecastingEnhancements: true,
    enableCanadaServiceEquipmentCityDisable: true,
    enableNegativeLaborHoursAdjustment: true,
    enableInvoiceWithLogic: true,
    enableBidIntegration: true,
    enableContractingCanadaCertificateTypes: true,
    enableOrderTrackerFeature: true,
    enableTaxDeterminationForAdditionalSuppliedProductCode: true,
    enableBillingStoredMaterials: true,
    enableEndUserFeedbackRelease310: true,
    enableServiceOfficeItems: true,
    enableServiceAgreementStartupAndLaborWarranty: true,
    enableEndUserFeedbackRelease311: true,
    enableProductReturnsWithSystemSelection: false,
    enableMomByWorkpackage: true,
    enableBillingIndependentOfficeUser: false
};
